import { api } from './client'
import type { Rival, RivalRequest } from '../types'

export function loadRivals(): Promise<Rival[]> {
  return api.get('/rivals')
}

export function loadRivalRequests(): Promise<RivalRequest[]> {
  return api.get('/rivals/requests')
}

export function challengeUser(userId: string): Promise<RivalRequest | { ok: true }> {
  return api.post(`/rivals/challenge/${userId}`)
}

export function acceptRivalRequest(requestId: string): Promise<{ ok: true }> {
  return api.post(`/rivals/requests/${requestId}/accept`)
}

export function declineRivalRequest(requestId: string): Promise<{ ok: true }> {
  return api.post(`/rivals/requests/${requestId}/decline`)
}

export function endRivalry(userId: string): Promise<{ ok: true }> {
  return api.delete(`/rivals/${userId}`)
}
